import { useFbClient, useFlags } from '@featbit/react-client-sdk'
import { isUndefined } from 'lodash'
import React, { useMemo } from 'react'
import FeatureFlagsContext, { FeatureFlagsContextValue } from './FeatureFlagsContext'
import { UseFlags } from './types'
import { mapFlags } from './utils/map-flags'
/**
 * Provider to provide feature flags and a loading state
 */
const FeatureFlagsProvider: React.FC<{ isFbClientOptionsReady: boolean; children: React.ReactNode }> = ({ isFbClientOptionsReady, children }) => {
  const featBitClient = useFbClient()
  const featureFlags = useFlags<UseFlags>()

  const isFeatureFlagsLoading = !isFbClientOptionsReady || isUndefined(featBitClient)
  const isFeatureFlagsError = !isFeatureFlagsLoading && Object.values(featureFlags).some(isUndefined)
  const mappedFeatureFlags = mapFlags(featureFlags, isFeatureFlagsError)

  const contextValue: FeatureFlagsContextValue = useMemo(() => {
    return {
      featureFlags: mappedFeatureFlags,
      isFeatureFlagsLoading,
      isFeatureFlagsError,
    }
  }, [mappedFeatureFlags, isFeatureFlagsLoading, isFeatureFlagsError])

  return <FeatureFlagsContext.Provider value={contextValue}>{children}</FeatureFlagsContext.Provider>
}

export default FeatureFlagsProvider
